import { Route, Routes } from "react-router-dom";
import { GUIDE_ROUTES, LANDING_PAGE_ROUTES, buildPrerenderEntries } from "@plaatplan/i18n";
import App from "../App";
import { GuidePage } from "../pages/GuidePage";
import { LandingPage } from "../pages/LandingPage";
import { NotFoundRedirect } from "./NotFoundRedirect";

/**
 * @param {{ basePath: string }} entry
 */
function renderRouteElement({ basePath }) {
  if (basePath === "/") {
    return <App />;
  }

  const landing = LANDING_PAGE_ROUTES.find((page) => page.paths.nl === basePath);
  if (landing) {
    return <LandingPage slug={landing.slug} />;
  }

  const guide = GUIDE_ROUTES.find((item) => item.paths.nl === basePath);
  if (guide) {
    return <GuidePage pageId={guide.pageId} />;
  }

  return <NotFoundRedirect />;
}

export function AppRoutes() {
  const routes = buildPrerenderEntries();

  return (
    <Routes>
      {routes.map((entry) => (
        <Route
          key={`${entry.locale}:${entry.basePath}`}
          path={entry.path}
          element={renderRouteElement(entry)}
        />
      ))}
      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  );
}
